/**
 * Copyright (c) 2025 Bytedance Ltd. and/or its affiliates
 * SPDX-License-Identifier: MIT
 */

export default {
  languageId: 'zh-CN',
  languageName: 'Chinese',
  localizedLanguageName: '中文(中国)',
  contents: {
    Yes: '是',
    No: '否',
  },
};
